module.exports = __webpack_public_path__ + "img/bandicam_00005.87c1ac70.png";